import { render, staticRenderFns } from "./addshop.vue?vue&type=template&id=5039bbdf&scoped=true&"
import script from "./addshop.vue?vue&type=script&lang=ts&"
export * from "./addshop.vue?vue&type=script&lang=ts&"
import style0 from "./addshop.vue?vue&type=style&index=0&lang=less&"
import style1 from "./addshop.vue?vue&type=style&index=1&id=5039bbdf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5039bbdf",
  null
  
)

export default component.exports